<template>
  <div>
    <ul id="nav">
      <li class="nav-l"><i class="icons icon-left"></i></li>
      <li ><i @click="onReload('/my/welcome')" class="icons icon-reload"></i><router-link href="/my/welcomes" to="/my/welcome">欢迎页</router-link></li>
      <li v-for="(item,idx) in NavCon" :key="idx"><i @click="onReload(item.path + (item.id ? item.id : ''))" class="icons icon-reload"></i><router-link :href="item.path + 's/' + (item.id ? item.id : '') " :to="item.path + (item.id ? item.id : '')">{{item.title}}</router-link><i @click="del(item.tig,idx)" class="icons icon-x"></i></li>
      <li class="nav-r"><i class="icons icon-right"></i></li>
    </ul>
    <transition name="loading-my-fade">
      <div class="loading-my" :class="{'loading-active':!LoadingMy }" v-if="LoadingMy"><i class="icon-reload-load" :class="{'my-hover': LoadingMy}"></i>正在加载页面...</div>
    </transition>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
const navConfig = [
  {
    tig: "jifen",
    title: "店铺积分",
    path: "/my/jifen"
  },
  {
    tig: "order",
    title: "订单列表",
    path: "/my/order"
  },
  {
    tig: "jifenDetil",
    title: "积分明细",
    path: "/my/jifen/",
    id: ""
  },
  {
    tig: "orderDetil",
    title: "订单详情",
    path: "/my/order/",
    id: ""
  }
];
export default {
  name: "Nav",
  computed: {
    ...mapGetters(["NavCon", "LoadingMy"])
  },
  watch: {
    $route: "fetchData"
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      let self = this;
      let name = self.$route.name;
      switch (name) {
        case "jifen":
          self.$store.dispatch("ADDNAV", navConfig[0]);
          break;
        case "order":
          self.$store.dispatch("ADDNAV", navConfig[1]);
          break;
        case "jifenDetil":
          if (navConfig[2].id != '' && navConfig[2].id != self.$route.params.id) {
            self.$store.dispatch("JIFENDETAIL", self.$route.params.id);
            self.$store.dispatch("SHOPINFO", self.$route.params.id);
          }
          navConfig[2].id = self.$route.params.id;
          self.$store.dispatch("ADDNAV", navConfig[2]);
          break;
        case "orderDetil":
          if (navConfig[3].id != '' && navConfig[3].id != self.$route.params.id) {
            self.$store.dispatch("GETORDERDETAIL", self.$route.params.id);
          }
          navConfig[3].id = self.$route.params.id;
          self.$store.dispatch("ADDNAV", navConfig[3]);
          break;
      }
    },
    del(tig, idx) {
      let self = this;
      this.$store.dispatch("DELNAV", tig);
      if (self.$route.name == tig) {
        if (self.NavCon.length == 0) {
          self.$router.push("/my/welcome");
          return;
        }
        let nc = self.NavCon;
        let isFath = nc[idx]
          ? nc[idx].path + (nc[idx].id ? nc[idx].id : "")
          : nc[idx - 1].path + (nc[idx - 1].id ? nc[idx - 1].id : "");
        self.$router.push(isFath);
      }
    },
    onReload(url){
      let self = this;
      self.$router.push(url);
      let name = self.$route.name;
      switch (name) {
        case "welcome":
          self.$store.dispatch("ORDERSTATE");
          break
        case "jifen":
          self.$store.dispatch("JIFENLIST");
          break;
        case "order":
          self.$store.dispatch("GETORDERLIST");
          break;
        case "jifenDetil":

          self.$store.dispatch("JIFENDETAIL", self.$route.params.id);
          self.$store.dispatch("SHOPINFO", self.$route.params.id);
          break;
        case "orderDetil":
          self.$store.dispatch("GETORDERDETAIL", self.$route.params.id);
          break;
      }
    }
  }
};
</script>
<style>
#nav {
  width: 100%;
  height: 30px;
  display: block;
  margin-top: -38px;
}

#nav li {
  float: left;
  border: 1px solid #eee;
  margin: 0 0 0 10px;
  padding: 0 12px;
  border-radius: 4px 4px 0 0;
  border-bottom: none;
  line-height: 36px;
  background-color: #fff;
  /* background-color: #f8f8f8; */
}
#nav .nav-l {
  margin: 0;
  padding: 0;
  border: none;
  background-color: #fff;
}
#nav .nav-r {
  margin: 0;
  padding: 0;
  float: right;
  border: none;
  background-color: #fff;
}
.icon-left {
  background-position: 0px -72px;
  display: inline-block;
  width: 21px;
  height: 21px;
  cursor: pointer;
  vertical-align: -6px;
}
.icon-right {
  background-position: -22px -73px;
  display: inline-block;
  width: 21px;
  height: 21px;
  cursor: pointer;
  vertical-align: -6px;
}
.icon-x {
  background-position: 0px 1px;
  display: inline-block;
  width: 14px;
  height: 14px;
  cursor: pointer;
  vertical-align: -2px;
  margin-left: 6px;
}
.icon-x:hover {
  background-color: #eee;
}
.icon-reload {
  background-position: 0px -54px;
  display: inline-block;
  width: 16px;
  height: 16px;
  cursor: pointer;
  vertical-align: -4px;
  margin-right: 8px;
  transition: 1s ease-in-out 0s;
  -moz-transition: 1s ease-in-out 0s;
  -webkit-transition: 1s ease-in-out 0s;
  -o-transition: 1s ease-in-out 0s;
  -webkit-backface-visibility: hidden;
}
.icon-reload:hover {
  -moz-transform: scale(1.1) rotate(360deg);
  -webkit-transform: scale(1) rotate(360deg);
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -moz-transition: 1s ease-in-out 0s;
  -webkit-transition: 1s ease-in-out 0s;
}
#nav a {
  color: #666;
}

#nav a.router-link-exact-active {
  color: #169bd5;
  margin: 0 0 1px 0;
  display: inline-block;
  padding: 0;
  outline: 0;
  border: none;
  background-color: #fff;
}
.loading-my {
  position: fixed;
  top: 200px;
  left: 50%;
  margin-left: -105px;
  color: #fff;
  width:210px;
  height:60px;
  line-height: 60px;
  font-size: 18px;
  background:rgba(0, 171, 255, 0.7);
  border-radius:30px;
  -ms-transform: translateX(-50%);
  transform: translateX(-50%);
  transition: opacity .3s,transform .4s;
  z-index: 99;
}
.loading-my-fade-enter,.loading-my-fade-leave-active{
  opacity:0;
  transform:translate(-50%,-100%)
}
.icon-reload-load {
  background: url(../assets/icon-reload.png) no-repeat;
  width: 32px;
  height: 32px;
  display: inline-block;
  vertical-align: -9px;
  margin-right: 10px;
  transition: 1s ease-in-out 0s;
  -moz-transition: 1s ease-in-out 0s;
  -webkit-transition: 1s ease-in-out 0s;
  -o-transition: 1s ease-in-out 0s;
  -webkit-backface-visibility: hidden;
}
.loading-my-fade-enter .icon-reload-load{
  animation: spin 1200ms infinite linear;
}
.my-hover {
  animation: spin 1200ms infinite linear;
}
 @keyframes spin {
    0%   { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
</style>
